import { Button, SelectOptionType } from '@octano/global-ui';
import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Col, Container, Form, Row } from 'reactstrap';
import useTexts from '../hooks/useTexts';
import {
  StudentRiskEvaluationSessionParticipant,
  StudentRiskEvaluationSessionResponse,
} from '../types';
import FormFields from './FormFields';

export interface CreateSessionForm {
  period: SelectOptionType | null;
  school: SelectOptionType | null;
  year: SelectOptionType | null;
  sessionName: string;
  sessionDate: Date;
  initDate: Date;
  endDate: Date;
  description: string | null;
  participant: SelectOptionType;
  participants: SelectOptionType[];
}

export const FormCreate = ({
  defaultValues,
  disabled,
  handleOnSumbit,
}: {
  defaultValues?: any;
  disabled?: boolean;
  handleOnSumbit: (values: StudentRiskEvaluationSessionResponse) => void;
}) => {
  const texts = useTexts();
  const methods = useForm<CreateSessionForm>({
    defaultValues,
    shouldUnregister: true,
  });

  const onSubmit = useCallback(
    async (values: CreateSessionForm) => {
      const {
        period,
        school,
        year,
        sessionName,
        description,
        sessionDate,
        initDate,
        endDate,
        participants,
      } = values;

      const auxParticipants: StudentRiskEvaluationSessionParticipant[] = [];

      if (participants && participants.length > 0) {
        participants.forEach((participant) => {
          auxParticipants.push({
            id: participant?.id ? +participant.id : undefined,
            accountId: participant?.value ? +participant.value : null,
            name: participant.name,
            email: participant.email,
          });
        });
      }

      if (
        school?.value === undefined ||
        period?.value === undefined ||
        year?.value === undefined ||
        description === null
      ) {
        return;
      }

      handleOnSumbit({
        schoolId: +school.value,
        periodId: +period.value,
        year: +year.value,
        name: sessionName,
        date: sessionDate,
        startAt: initDate,
        endAt: endDate,
        participants: auxParticipants,
        description,
      });
    },
    [handleOnSumbit],
  );

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
              <FormFields disabled={disabled} />

              <Row className="py-5 justify-content-end pt-5">
                <Col xs={12} lg={3} className="pb-2 order-1 order-lg-2">
                  <Button
                    type="submit"
                    text={texts.actions.saveChanges}
                    loading={methods.formState.isSubmitting}
                    fullwidth
                  />
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </Col>
      </Row>
    </Container>
  );
};
